import { cva } from 'class-variance-authority';

const iconVariants = cva('', {
  variants: {},
  compoundVariants: [],
  defaultVariants: {},
});

export { iconVariants };
